export default __webpack_public_path__ + "static/media/menu_bar.94bc0897.svg";